import { Molecule, wrap } from "AppReact";
import styled from "styled-components";
import {
  HappyEmojiSvg,
  SadFaceEmojiSvg,
  NormalFaceEmojiSvg,
} from "components/icons";
import { Icon } from "./atoms";
import { GenericWrapper, Mb2, TextCenterWrapper } from "wrappers";
import { SecondaryTextSm } from "atoms";

const template = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export default Molecule({
  template: template,
  atoms: [
    {
      wrapper: GenericWrapper,
      name: "VeryHappyEmojiWrapper",
      atoms: [
        {
          component: wrap(Icon, Mb2),
          name: "VeryHappyEmoji",
          displayValue: ({}) =>
            HappyEmojiSvg({
              width: "18",
              height: "18",
              filled: true,
              color: "#9BADB1",
            }),
        },
        {
          component: wrap(SecondaryTextSm, TextCenterWrapper),
          name: "Count",
          displayValue: ({ ratings }) =>  ratings?.veryGood > 0 ?  String(ratings.veryGood) : "0",
        },
      ],
    },
    {
      wrapper: GenericWrapper,
      name: "NormalHappyWrapper",
      atoms: [
        {
          component: wrap(Icon, Mb2),
          name: "NormalHappyEmoji",
          displayValue: ({ rating }) =>
            NormalFaceEmojiSvg({
              width: "18",
              height: "18",
              filled: true,
              color: "#9BADB1",
            }),
        },
        {
          component: wrap(SecondaryTextSm, TextCenterWrapper),
          name: "Count",
          displayValue: ({ ratings }) =>  ratings?.good > 0 ?  String(ratings.good) : "0",
        },
      ],
    },
    {
      wrapper: GenericWrapper,
      name: "SadEmojiWrapper",
      atoms: [
        {
          component: wrap(Icon, Mb2),
          name: "SadEmoji",
          displayValue: ({ rating }) =>
            SadFaceEmojiSvg({
              width: "18",
              height: "18",
              filled: true,
              color: "#9BADB1",
            }),
        },
        {
          component: wrap(SecondaryTextSm, TextCenterWrapper),
          name: "Count",
          displayValue: ({ ratings }) =>  ratings?.bad > 0 ?  String(ratings.bad) : "0",
        },
      ],
    },
  ],
});
